var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('IconBox',{attrs:{"icon-data-list":_vm.personalDataIconList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }